import React from "react";
import { Message, MessageProps } from "semantic-ui-react";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";

import "./message-block.scss";
import {Icon} from "../icon/icon";

class MessageBlock extends React.Component<MessageProps, any> {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    state = { visible: true};
    messageId;
    dismiss: string[] = [];
    constructor(props: MessageProps) {
        super(props);
        const { cookies, topic, subtopic, index } = this.props;
        const cookieString = cookies.get("mv-dismiss");
        this.messageId = topic +(subtopic? "_"+subtopic:"")+ "_" + index;
        this.dismiss = cookieString? cookieString.split(";"): [];
        this.state = {
            visible: !this.dismiss.includes(this.messageId)
        };
        this.handleDismiss = this.handleDismiss.bind(this);
    }
    handleDismiss = (): void => {
        const { cookies } = this.props;
        this.setState({ visible: false });
        this.dismiss.push(this.messageId);
        cookies.set("mv-dismiss", this.dismiss.join(";"), { path: "/", sameSite: "lax" });
    };

    render(): React.ReactElement | null {
        if (this.state.visible && this.props.content) {
            let className = "geo-component";
            if (this.props.className) {
                className += " " + this.props.className;
            }
            // quick and dirty!
            const content = (
                <div>
                    <Icon onClick={this.handleDismiss} className={"close"} name="navigate_cross"
                        title={"Hinweis schliessen"} />
                    <p dangerouslySetInnerHTML={{__html: this.props.content as string}}/>
                </div>
            );
            return (
                <Message floating
                    className={className}
                    info={true}
                    header={this.props.header}
                    content={content}
                />
            );
        }

        return null;
    }
}
export default withCookies(MessageBlock);
